"use client"
import React from 'react';
import {useArrayFilter} from "@/hook/useArrayFilter";
import {useDateFormatter} from "@/hook/dateFormater";
import {SingleProductEnum} from "@/constants/commerce-enum";

function VariationDetailsComponentMobile({data}: any) {
    const filterOptions = useArrayFilter();
    const formatDate = useDateFormatter();

    const filteredVariations = data?.data?.variations?.map((variation: any) => ({
        title: variation?.title,
        options: filterOptions(variation?.options, data?.data?.variationOptions),
    }));

    const earliestExpiryItem = data?.data?.productItem
    const earliestExpiryDate = earliestExpiryItem?.expired_at ? formatDate(earliestExpiryItem.expired_at) : "-";

    return (
        <div className="w-full flex flex-wrap gap-y-4 h-fit font-medium py-5 items-center justify-between">
            {filteredVariations?.map((variation: any, index: number) => (
                <div key={index} className="w-1/2 flex md:justify-start  items-center gap-1">
                    <div className="text-gray-400 ">
                        {variation.title}:
                    </div>
                    <div>
                        {variation.options?.length
                            ? variation.options.map((item: any) => item?.title).join(', ')
                            : "-"}
                    </div>
                </div>
            ))}

            {data?.data?.product?.product_items ? (
                <div className="w-1/2 flex md:justify-start gap-1">
                    <div className="text-gray-400">{SingleProductEnum.expirationDate}:</div>
                    <div>{earliestExpiryDate}</div>
                </div>
            ) : null}

            {data?.data?.productItem?.shipping_days ? (
                <div className="w-1/2 flex gap-1">
                    <div className="text-gray-400">{SingleProductEnum?.sipplyForProducts}:</div>
                    <div>
                        {SingleProductEnum.from}
                        <span className="px-0.5">
                            {data.data.productItem.shipping_days.toLocaleString("fa")}
                        </span>
                        {SingleProductEnum?.nextDay}
                    </div>
                </div>
            ) : null}


            <strong>{data?.productItem?.seller?.title}</strong>
            <div className="w-1/2 flex md:hidden gap-1">
                <span className="text-gray-400">{SingleProductEnum?.seller} :</span>
                <strong>{data?.data?.productItem?.seller?.title}</strong>
            </div>

        </div>
    );
}

export default VariationDetailsComponentMobile;
